import { render, staticRenderFns } from "./UserRowSimple.vue?vue&type=template&id=149523f4&"
import script from "./UserRowSimple.vue?vue&type=script&lang=js&"
export * from "./UserRowSimple.vue?vue&type=script&lang=js&"
import style0 from "./UserRowSimple.vue?vue&type=style&index=0&id=149523f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports